import { Typography, TypographyProps } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useInstantSearch } from 'react-instantsearch'

export function SearchPageTitle(props: TypographyProps) {
  const { uiState } = useInstantSearch()
  const t = useTranslations('SearchPageTitle')

  const coursesSearchQuery = uiState['courses']?.query

  return (
    <Typography {...props}>
      {coursesSearchQuery
        ? t('courses_suffix', { query: coursesSearchQuery })
        : t('search')}
    </Typography>
  )
}
